import { render, staticRenderFns } from "./DraftScroll.vue?vue&type=template&id=58a9ab05&"
import script from "./DraftScroll.vue?vue&type=script&lang=js&"
export * from "./DraftScroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports